import { translate } from '../../../../../react/features/base/i18n/functions';
import {
    createLocalizedTime
} from '../../../../../react/features/speaker-stats/components/timeFunctions';
import React, { Component } from 'react';

/**
 * The type of the React {@code Component} props of {@link HintsNotification}.
 */
type Props = {

    /**
     * The function to translate human-readable text.
     */
    t: Function,

    /**
     * The milliseconds to be converted into a human-readable format.
     */
    user: Object
};

class HintsNotification extends Component<Props> {
    constructor(props) {
        super(props);
    }

    render() {
        const { user, t } = this.props;

        const time = createLocalizedTime(user.longestMonolog || 0, t);

        return (
            <div className = 'hints-notification'>
                <div>{t('hints.talkRatio')}: {user.ratio}%</div>
                <div>{t('speakerStats.monologue')}: {time}</div>
            </div>
        );
    }
}

export default translate(HintsNotification);
